// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Brand theming for the OrderFlow V2 help tour (driver.js popovers).
   Scoped via the \`orderflow-tour\` popoverClass set in useOrderFlowTour. */

.driver-popover.orderflow-tour {
  font-family: 'Manrope', sans-serif;
  border-radius: 10px;
  max-width: 320px;
  padding: 16px;
}

.driver-popover.orderflow-tour .driver-popover-title {
  font-size: 16px;
  font-weight: 700;
  color: #1c1c1c;
}

.driver-popover.orderflow-tour .driver-popover-description {
  font-size: 14px;
  line-height: 1.5;
  color: #4a4a4a;
}

.driver-popover.orderflow-tour .driver-popover-progress-text {
  font-size: 12px;
  color: #979797;
}

.driver-popover.orderflow-tour .driver-popover-footer button {
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 13px;
  text-shadow: none;
  border-radius: 6px;
  padding: 6px 14px;
}

.driver-popover.orderflow-tour .driver-popover-next-btn {
  background-color: #44a735;
  color: #fff;
  border: 1px solid #44a735;
}

.driver-popover.orderflow-tour .driver-popover-next-btn:hover {
  background-color: #3c9530;
  border-color: #3c9530;
}

.driver-popover.orderflow-tour .driver-popover-prev-btn {
  background-color: #fff;
  color: #1c1c1c;
  border: 1px solid #dadada;
}

/* First-entry image tour: wider popover to fit the reference crop, plus the
   crop-window + instruction blocks embedded in the popover description. */
.driver-popover.orderflow-tour-image {
  max-width: 360px;
}

.orderflow-tour-crop {
  display: block;
  width: 320px;
  max-width: 100%;
  background-repeat: no-repeat;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  margin: 2px 0 12px;
}

.orderflow-tour-instruction {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Agency/CreateOrderV2/tour/orderflowTour.css"],"names":[],"mappings":"AAAA;0EAC0E;;AAE1E;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;0EAC0E;AAC1E;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Brand theming for the OrderFlow V2 help tour (driver.js popovers).\n   Scoped via the `orderflow-tour` popoverClass set in useOrderFlowTour. */\n\n.driver-popover.orderflow-tour {\n  font-family: 'Manrope', sans-serif;\n  border-radius: 10px;\n  max-width: 320px;\n  padding: 16px;\n}\n\n.driver-popover.orderflow-tour .driver-popover-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1c1c1c;\n}\n\n.driver-popover.orderflow-tour .driver-popover-description {\n  font-size: 14px;\n  line-height: 1.5;\n  color: #4a4a4a;\n}\n\n.driver-popover.orderflow-tour .driver-popover-progress-text {\n  font-size: 12px;\n  color: #979797;\n}\n\n.driver-popover.orderflow-tour .driver-popover-footer button {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 600;\n  font-size: 13px;\n  text-shadow: none;\n  border-radius: 6px;\n  padding: 6px 14px;\n}\n\n.driver-popover.orderflow-tour .driver-popover-next-btn {\n  background-color: #44a735;\n  color: #fff;\n  border: 1px solid #44a735;\n}\n\n.driver-popover.orderflow-tour .driver-popover-next-btn:hover {\n  background-color: #3c9530;\n  border-color: #3c9530;\n}\n\n.driver-popover.orderflow-tour .driver-popover-prev-btn {\n  background-color: #fff;\n  color: #1c1c1c;\n  border: 1px solid #dadada;\n}\n\n/* First-entry image tour: wider popover to fit the reference crop, plus the\n   crop-window + instruction blocks embedded in the popover description. */\n.driver-popover.orderflow-tour-image {\n  max-width: 360px;\n}\n\n.orderflow-tour-crop {\n  display: block;\n  width: 320px;\n  max-width: 100%;\n  background-repeat: no-repeat;\n  border: 1px solid #eaeaea;\n  border-radius: 8px;\n  margin: 2px 0 12px;\n}\n\n.orderflow-tour-instruction {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
